
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { CharacterBackButton } from "./CharacterBackButton";

export const CharacterDetailError = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-sky-blue/10 to-teedee-blue/10">
      <Navbar />
      
      <main className="py-8" role="main">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="bg-red-50 border border-red-200 rounded-lg p-8 max-w-md mx-auto" role="alert">
              <h1 className="text-2xl font-bold text-red-600 mb-4">
                Character Not Found
              </h1>
              <p className="text-red-600 mb-6">
                Sorry, we couldn't find the character you're looking for.
              </p>
              <CharacterBackButton />
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};
